// services/CodService.js
import config from "../config/config";
import { apiConfig } from "../config/apiConfig";
import ApiService from "./apiService";

class CodService {
  static instance;

  constructor() {
    if (!CodService.instance) {
      this.apiService = new ApiService(config["backend-url"]);
      CodService.instance = this;
    }
    return CodService.instance;
  }

  async addUserFromCOD({ email, fullName, requestorEmail, token }) {
    const payload = {
      email,
      fullName,
      requestorEmail,
      userType: "COD",
    };

  
    return await this.apiService.post(
      apiConfig.CODAdmin.addUserFromCOD,
      payload,
      true,
      
    );
  }

  // ✅ NEW: getAllUsersForCOD
  async add_Customer(payload) {
   


    return await this.apiService.post(
      apiConfig.CODAdmin.addCustomer,
      payload,
      true
    );
  }
  async getSubscriptionPlans() {
   
    return await this.apiService.get(
      apiConfig.CODAdmin.getSubscriptionPlans,
      true,
    
     
    );
  }



  async getCountriesWithPagination(page = 1, limit = 10) {
    try {
      const endpoint = `${apiConfig.CODAdmin.getCountriesWithPagination}?page=${page}&limit=${limit}`;
      const response = await this.apiService.get(endpoint, true);
  
      // ✅ Fix: ensure we access the actual data array
      const countries = response.data.data.map((country) => ({
        id: country.id,
        diligence: country.Diligence || "Standard",
        country: country.country,
        status: country.is_active,
      }));
  
      return {
        countries,
        pagination: response.data.pagination,
      };
    } catch (error) {
      console.error("❌ Error in getCountriesWithPagination:", error);
      throw error;
    }
  }





  // === ✅ NEW: Toggle status of a country row ===
  async updated_row(row, status) {
    try {
      const payload = {
        tableName: "Country",
        row: {
          id: row.id,
          country: row.country,
          Deligence: row.diligence,
          is_active: row.status,
        },
        status, // "Activate" or "Deactivate"
      };

      return await this.apiService.post(
        apiConfig.CODAdmin.updateTable,
        payload,
        true
      );
    } catch (error) {
      console.error("❌ Failed to toggle row status:", error);
      throw error;
    }
  }
}

export const codService = new CodService();
